export default __webpack_public_path__ + "static/media/20.fa1329ef.svg";